import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import ReleaseIndexApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/releases/components/app_index.vue?vue3';

export default () => {
  const el = document.getElementById('js-releases-page');

  Vue.use(VueApollo);

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(),
  });

  return initVueApp({
    el,
    name: 'ReleaseIndexAppRoot',
    apolloProvider,
    provide: { ...el.dataset },
    component: ReleaseIndexApp,
  });
};
